import { useAtom, type WritableAtom } from 'jotai';
import { useHydrateAtoms } from 'jotai/utils';
import { useEffect } from 'react';

type AtomsToHydrate<T> = Array<readonly [WritableAtom<T, [T], unknown>, T]>;

type AtomsHydratorProps<T> = {
  initialValues: Array<AtomsToHydrate<T>[number]> | ReadonlyArray<AtomsToHydrate<T>[number]>;
  children: JSX.Element;
};

export default function AtomsHydrator<T>({ initialValues, children }: AtomsHydratorProps<T>) {
  useHydrateAtoms(new Map(initialValues));

  // Hydrate the first atom with its value. this needs to update the atom state
  // https://github.com/pmndrs/jotai/discussions/2087
  const [atomToHydrate, value] = initialValues[0];
  const [, setValue] = useAtom(atomToHydrate);
  useEffect(() => {
    setValue(value);
  }, [setValue, value]);
  return children;
}
